import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import logoImg from "../public/logo.png";

export function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className="price-errors dark">
      {/* Scanline overlay */}
      <div className="scanlines" />

      {/* Noise texture overlay */}
      <div className="noise" />

      {/* Grid overlay for futuristic feel */}
      <div className="grid-overlay" />

      {/* Navigation */}
      <nav className="nav">
        <div className="nav-inner">
          <Link to="/" className="nav-logo">
            <img src={logoImg} alt="Price Errors" />
            <span className="nav-logo-text">PRICE ERRORS</span>
          </Link>
          <div className="nav-links">
            {location.pathname === '/' && (
              <>
                <a href="#what-we-do">Services</a>
                <a href="#how-to-join">Join</a>
                <a href="#why-us">Why Us</a>
              </>
            )}
            <a href="https://discord.gg/q7tErztQDQ" className="nav-cta" target="_blank" rel="noopener noreferrer">
              Join Discord
            </a>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main>
        {children}
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <img src={logoImg} alt="Price Errors" className="footer-logo" />
            <p className="footer-tagline">Real-Time Deals & Price Errors</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-heading">Services</h4>
              <a href="https://www.pricingerrors.com/" target="_blank" rel="noopener noreferrer">Get Deal Alerts</a>
              <a href="https://www.pricingerrors.com/add" target="_blank" rel="noopener noreferrer">Add Discord Webhook</a>
            </div>
            <div className="footer-column">
              <h4 className="footer-heading">Community</h4>
              <a href="https://discord.gg/q7tErztQDQ" target="_blank" rel="noopener noreferrer">Free Discord Community</a>
              <a href="https://x.com/Pricerrors" target="_blank" rel="noopener noreferrer">Follow on X</a>
            </div>
            <div className="footer-column">
              <h4 className="footer-heading">Legal</h4>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-disclaimer">
            Price Errors is not affiliated with or endorsed by any retailer. All deals are subject to change or expiration.
          </p>
          <p className="footer-copyright">
            © {new Date().getFullYear()} Price Errors. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
